import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-productEdit",
  "use": "icon-productEdit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-productEdit\"><defs><style type=\"text/css\"></style></defs><path d=\"M988.8 529.28a120.32 120.32 0 0 0 0-169.6L664.32 35.2a120.32 120.32 0 0 0-169.6 0l-339.2 339.2L649.6 868.48zM35.2 494.72a120.32 120.32 0 0 0 0 169.6L359.68 988.8a120.32 120.32 0 0 0 169.6 0l78.08-78.08-494.08-494.08z\" p-id=\"17752\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol